import { classNames, tv } from "../../utils"

export const overlayVariants = tv({
  base: classNames(
    "fixed inset-0 z-overlay bg-overlay ease-out-quint",
    "data-[state=closed]:animate-out data-[state=open]:animate-in",
    "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
  ),
  variants: {
    open: {
      true: "fade-in-0 animate-in",
      false: "fade-out-0 animate-out",
    },
  },
})
